class SectionDifferentDevices implements ng.IComponentController {
    ltTitle: string;
    description: string;
    buttons: anm.LandingButtonData[];
    videos: anm.LandingVideo[];
}

angular.module('animatronApp.sectionDifferentDevices', []).component('sectionDifferentDevices', {
    bindings: {
        ltTitle: '<',
        buttons: '<?',
        description: '<',
        videos: '<'
    },
    controller: SectionDifferentDevices,
    templateUrl: require('landing-template/components/sections/section-different-devices.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionDifferentDevices.ts